import PaidBankAccountSection, { IPaidBankAccountSectionProps } from "./PaidBankAccountsSection";

export default PaidBankAccountSection;
export type { IPaidBankAccountSectionProps };
